// ======================================================================
// File Name       : ContentDocumentContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues, change } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Form, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import EnterpriseNoticeRegisterEditForm from '../../components/enterpriseNotification/EnterpriseNoticeRegisterEditForm';
import DialogConfirm from '../../components/DialogConfirm';
import * as EnterpriseAction from '../../actions/EnterpriseAction';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { USE_DATE_RELEASE, PUBLIC_STATUS, RELEASE_TARGET_NOTICE_FOR_ENTERPRISE } from '../../constants/EnterpriseNoticeConstants';
import { VALIDATE_TYPE,
  RETURN_MAX_NUM,
  DEFAULT_DATE_FORMAT_SERVER,
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_FROM,
  DEFAULT_DATE_TO,
  DEFAULT_DATE_TO_TEXT,
  DEFAULT_DATE_FROM_TEXT, 
  WRITE} from '../../constants/index';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import { getItemBoxName, parseDateForDetail, getDisplayPublicPeriod } from '../../utils/index';
import * as Path from '../../constants/PathConstants';
import { ENTERPRISE_NOTIFICATION_LIST } from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';
import { ENTERPRISE_NOTIFICATION_EDIT } from '../../constants/FunctionConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';

class EnterpriseNoticeDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noticeInfo: {
        noticeSecernId: null,
        noticeTitle: null,
        noticeContent: null,
        releaseTargetForEnterprise: 0,
        publicStatus: 1,
        publicDateFrom: null,
        publicDateTo: null,
        releasePeriod: USE_DATE_RELEASE.INDEFINITE_PERIOD,
      },
    };

    this.createParams = this.createParams.bind(this);
    this.getDetailOfNoticeEnterprise = this.getDetailOfNoticeEnterprise.bind(this);
    this.deleteNoticeForEnterprise = this.deleteNoticeForEnterprise.bind(this);
    this.openConfirmDialog = this.openConfirmDialog.bind(this, MessageTemplate.MSG_DEL_ENTERPRISE_NOTICE, null);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    this.getDetailOfNoticeEnterprise(match.params.id);
  }

  getDetailOfNoticeEnterprise(noticeForEnterpriseSecernId) {
    if (noticeForEnterpriseSecernId) {
      const param = this.createParams(noticeForEnterpriseSecernId);
      this.props.dispatch(EnterpriseAction.getNoticeForEnterpriseDetail(param));
    }
  }

  createParams(noticeForEnterpriseSecernId) {
    const param = {
      selectTargetData: 0,
      searchInfo: {
        noticeList: [noticeForEnterpriseSecernId],
      },
    };
    return param;
  }

  onDeleteCancel() {
    this.setState({ showModal: false });
  }

  openConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  deleteNoticeForEnterprise() {
    const { noticeInfo, history } = this.props;
    this.props.dispatch(EnterpriseAction.deleteNoticeForEnterprise(noticeInfo)).then(
      () => {
        history.push(ENTERPRISE_NOTIFICATION_LIST);
      },
    );
  }

  render() {
    const { noticeInfo, readOnlyFlag, userSecernId } = this.props;
    const canEditNoticeForEnterprise = canAccessRoute(ENTERPRISE_NOTIFICATION_EDIT);
    const id = this.props.match.params.id;
    const to = `/notice/noticeForEnterprise/${id}/edit`;
    const createdAtTemp = noticeInfo && noticeInfo.createdAt ? moment(noticeInfo.createdAt).format(DEFAULT_DATE_FORMAT) : '';
    const publicPeriod = getDisplayPublicPeriod(noticeInfo.publicDateFrom, noticeInfo.publicDateTo);
    const title = noticeInfo && noticeInfo.noticeTitle ? noticeInfo.noticeTitle : '';
    const noticeContent = noticeInfo && noticeInfo.noticeContent ? noticeInfo.noticeContent : '';
    const publicStatus = noticeInfo && noticeInfo.publicStatus ? noticeInfo.publicStatus : 0;
    const authorName = noticeInfo && noticeInfo.authorName ? noticeInfo.authorName : '';
    const releaseTargetForEnterprise = noticeInfo && noticeInfo.releaseTargetForEnterprise ? noticeInfo.releaseTargetForEnterprise : 0;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.ENTERPRISE_NOTIFICATION_LIST}
          text="企業向けお知らせ一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Form
          className='form-horizontal'
        >
          <Header name="企業向けお知らせ情報の詳細" />
          <Col className="padding-left-15 padding-right-15">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                タイトル
              </Col>
              <Col as={Form.Label} sm={8}>
                {title}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                お知らせ内容
              </Col>
              <Col as={Form.Label} sm={8}>
                {noticeContent}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                公開ステータス
              </Col>
              <Col as={Form.Label} sm={8}>
                { getItemBoxName(PUBLIC_STATUS, publicStatus) }
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                登録日
              </Col>
              <Col as={Form.Label} sm={8}>
                {createdAtTemp}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                登録者
              </Col>
              <Col as={Form.Label} sm={8}>
                {authorName}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
                公開期間
              </Col>
              <Col sm={8} as={Form.Label}>
                {publicPeriod}
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={4}>
              公開範囲
              </Col>
              <Col as={Form.Label} sm={8}>
                { getItemBoxName(RELEASE_TARGET_NOTICE_FOR_ENTERPRISE, releaseTargetForEnterprise) }
              </Col>
            </Form.Group>
          </Col>
          {userSecernId === noticeInfo.authorSecernId && ( // Step9.0.0
            <Col className="text-center margin-top-20">
              {/* sprint_20230418 #12 START */}
              {!readOnlyFlag && canEditNoticeForEnterprise && (
                <>
                  <LinkContainer to={to} className="btn-96 margin-10">
                    <Button
                      variant="primary"
                      className="btn-96 margin-10"
                    >
                      編集
                    </Button>
                  </LinkContainer>
                  <Button variant="primary" className="btn-96 margin-10" onClick={this.openConfirmDialog}>
                    削除
                  </Button>
                </>
              )}
              {/* sprint_20230418 #12 END */}
            </Col>
          )}
        </Form>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.deleteNoticeForEnterprise}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { noticeInfo } = state.enterpriseNotice;
  const { authedUser: { readOnlyFlag } } = state.authed;
  const { userSecernId } = state.authed.authedUser.userInfo // Step9.0.0
  return {
    ...{ noticeInfo },
    initialValues: noticeInfo,
    readOnlyFlag, // sprint_20230418 #12
    userSecernId, // Step9.0.0
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'EnterpriseNoticeDetail', // a unique identifier for this form
  enableReinitialize: true,
})(EnterpriseNoticeDetailContainer));
